import { AppConstants } from "../../../app.constants";
import { RSSClockFormat } from "../../enums/rss-clock-format.enum";
import { RSSClockPlacement } from "../../enums/rss-clock-placement.enum";
import { RssScrollDirection } from "../../enums/rss-scroll-direction-enum";
import { CustomFileModel } from "./file.type";

export class RssTickerConfigs {
  Id: number;
  PlaylistItemId: number;
  FileId: string;
  File: CustomFileModel;
  FileName: string;
  Url: string;
  TextSize: number;
  ScrollSpeed: number;
  TextColor: string;
  BackgroundColor: string;
  MaxAge: number;
  IncludeTitle: boolean;
  IncludeContent: boolean;
  ScrollDirection: RssScrollDirection;
  ShowSeconds: boolean;
  ClockFormat: RSSClockFormat;
  ClockPosition: RSSClockPlacement;
  PositionY: number;
  ShowClock: boolean;

  constructor() {
    this.TextColor = AppConstants.RSS_TICKER_DEFAULT_TEXT_COLOR;
    this.BackgroundColor = AppConstants.RSS_TICKER_DEFAULT_BACKGROUND_COLOR;
    this.ScrollSpeed = AppConstants.RSS_TICKER_DEFAULT_SCROLL_SPEED;
    this.TextSize = AppConstants.RSS_TICKER_DEFAULT_TEXT_SIZE;
    this.ScrollDirection = RssScrollDirection.RightToLeft;
    this.MaxAge = AppConstants.RSS_TICKER_DEFAULT_MAX_ARTICLE_AGE;
    this.IncludeContent = true;
    this.IncludeTitle = true;
    this.ShowSeconds = true;
    this.ShowClock = true;
    this.ClockFormat = RSSClockFormat.TwelveHour;
    this.ClockPosition = RSSClockPlacement.Right;
  }
}
